module.exports = __webpack_public_path__ + "img/shandong.b0d8a168.png";